import { App, APP_TIERS } from '@cccom/config/app-type';
import { EnvironmentType } from '@cccom/config/env';
import { i18n } from '@cccom/shared/i18n';
import {
  alarmReviewTheme,
  elogbookTheme,
  homeTheme,
  qiTheme,
  systemInventoryTheme,
  viewTheme,
} from '@cccom/shared/themes';

const HOME: App = {
  id: 'HOME',
  name: 'HOME',
  status: 'ACTIVE',
  logo: 'images/CClogo.svg',
  path: '/',
  port: ':3000',
  theme: homeTheme,
  errorLogo: 'images/cc-404-graphic.svg',
  homePage: '/',
  appFamily: 'Solutions',
  scopes: ['CC_USER'],
  helpCenter: 'HOME',
};

const QI: App = {
  id: 'QI',
  name: 'QI',
  status: 'ACTIVE',
  logo: 'images/qi/logo.svg',
  path: '/qi',
  port: ':3001',
  theme: qiTheme,
  errorLogo: 'images/qi/404-graphic.svg',
  homePage: '/qi',
  appFamily: 'QI',
  scopes: ['QI_USER'],
  description: i18n.t('qi.description'),
  helpCenter: 'QI',
};

const ATREVIEW: App = {
  id: 'ATREVIEW',
  name: 'ATReview',
  status: 'ACTIVE',
  logo: 'images/view/logo.svg',
  path: '/view/atreview',
  port: ':3002',
  theme: viewTheme,
  errorLogo: 'images/view/404-graphic.svg',
  homePage: '/view/atreview',
  appFamily: 'VIEW',
  scopes: ['ATREVIEW_USER'],
  description: i18n.t('atreview.atreview.description'),
  helpCenter: 'ATREVIEW',
};

const ELOGBOOK: App = {
  id: 'ELOGBOOK',
  name: 'eLogbook',
  status: 'ACTIVE',
  logo: 'images/elogbook/logo.svg',
  path: '/view/elogbook',
  port: ':3004',
  theme: elogbookTheme,
  errorLogo: 'images/elogbook/404-graphic.svg',
  homePage: '/view/elogbook',
  appFamily: 'VIEW',
  scopes: ['ELOGBOOK_USER'],
  description: i18n.t('elogbook.description'),
  helpCenter: 'ATREVIEW',
};

const ALARM_REVIEW: App = {
  id: 'ALARM_REVIEW',
  name: 'Alarm Review',
  status: 'ACTIVE',
  logo: 'images/alarm-review/logo.svg',
  path: '/view/alarm-review',
  port: ':3005',
  theme: alarmReviewTheme,
  errorLogo: 'images/alarm-review/404-graphic.svg',
  homePage: '/view/alarm-review',
  appFamily: 'VIEW',
  scopes: ['ALARM_REVIEW_USER'],
  description: i18n.t('alarm_review.description'),
  helpCenter: 'ATREVIEW',
};

const UNAUTHORIZED: App = {
  id: 'UNAUTHORIZED',
  name: 'UNAUTHORIZED',
  status: 'ACTIVE',
  logo: 'images/CClogo.svg',
  path: '/unauthorized',
  port: ':402',
  theme: homeTheme,
  errorLogo: 'images/unauthorized.svg',
  homePage: '/home',
  appFamily: '',
  scopes: [],
  helpCenter: 'ATREVIEW',
};

export const SYSTEM_INVENTORY: App = {
  id: 'SYSTEM_INVENTORY',
  name: 'System Inventory',
  status: 'ACTIVE',
  logo: 'images/system-inventory/logo.svg',
  path: '/view/system-inventory',
  port: ':3003',
  theme: systemInventoryTheme,
  errorLogo: 'images/system-inventory/cc-404-graphic.svg',
  homePage: '/view/system-inventory',
  appFamily: 'VIEW',
  scopes: ['SYSTEM_INVENTORY_USER'],
  description: i18n.t('system_inventory.description'),
  helpCenter: 'ATREVIEW',
  tier: APP_TIERS.REGISTRY_TIER,
};

const DefaultAppList = [ATREVIEW, QI, SYSTEM_INVENTORY, ELOGBOOK];

export const getUrl = (env: EnvironmentType, app: App) => {
  const { protocol, hostname } = window.location;
  const appPath = env.production ? app.homePage : app.port;
  return `${protocol}//${hostname}${appPath}`;
};

export const APPS = {
  HOME,
  QI,
  ATREVIEW,
  SYSTEM_INVENTORY,
  ELOGBOOK,
  ALARM_REVIEW,
  UNAUTHORIZED,
  DefaultAppList,
  getUrl,
};
